

export const LEAVE_TYPE = 1
export const SICK_LEAVE_TYPE = 2
export const ANNUAL_LEAVE_TYPE = 3
export const MARRIAGE_LEAVE_TYPE = 4
export const FUNERAL_LEAVE_TYPE = 5
export const MATERNITY_LEAVE_TYPE = 6
export const PATERNITY_LEAVE_TYPE = 7
export const TUNE_OFF_LEAVE_TYPE = 8
export const PAID_SICK_LEAVE_TYPE = 10
export const OTHER_LEAVE_TYPE = 9
export const PRODUCTION_LEAVE_TYPE = 11

// 假期管理
export const leaveList = [
  { name: '事假', value: LEAVE_TYPE },
  { name: '病假', value: SICK_LEAVE_TYPE },
  { name: '年假', value: ANNUAL_LEAVE_TYPE },
  { name: '婚假', value: MARRIAGE_LEAVE_TYPE },
  { name: '丧假', value: FUNERAL_LEAVE_TYPE },
  { name: '产假', value: MATERNITY_LEAVE_TYPE },
  { name: '陪产假', value: PATERNITY_LEAVE_TYPE },
  { name: '产检假', value: PRODUCTION_LEAVE_TYPE },
  { name: '调休', value: TUNE_OFF_LEAVE_TYPE },
  { name: '带薪病假', value: PAID_SICK_LEAVE_TYPE },
  { name: '其他', value: OTHER_LEAVE_TYPE }
]

export const getLeaveName = (type) => {
  if (typeof type !== 'number') {
    type = Number(type)
  }
  const result = leaveList.find(item => item.value === type)
  return typeof result === 'undefined' ? '-' : result.name
}

// 必须上传附件：病假 婚假 产假 产检假 陪产假
export const mustUploadAttachmentTypes = [
  SICK_LEAVE_TYPE,
  MARRIAGE_LEAVE_TYPE,
  MATERNITY_LEAVE_TYPE,
  PRODUCTION_LEAVE_TYPE,
  PATERNITY_LEAVE_TYPE,
  PAID_SICK_LEAVE_TYPE
]


// WEBPACK FOOTER //
// ./src/config/leaveType.js